import * as React from 'react'
import { Select } from 'antd'
import { KeyValueModel } from '../../models/ModelBase'

export const renderOptionsKeyValue = (data: Array<KeyValueModel>) => {
    if (data == null) return
    return data.map(e => ({ label: e.Value, value: e.Key }))
}

export const renderSelectKeyValue = (source: Array<KeyValueModel>) => {
    if (source == null) return
    let items = source.map((it) =>
        <Select.Option key={it.Key} value={it.Key}>{it.Value}</Select.Option>
    )

    return items
}

export const renderSelectKeyValuePrefix = (keyPrefix: string, source: Array<KeyValueModel>) => {
    if (source == null) return
    let items = source.map((it) =>
        <Select.Option key={`${keyPrefix}-${it.Key}`} value={it.Key}>{it.Value}</Select.Option>
    )

    return items
}

export const renderSelectModel = <T extends any>(source: Array<T>, key: keyof T, value: keyof T) => {
    if (source == null) return
    let items = source.map((it: T) =>
        <Select.Option key={it[key.toString()]} value={it[key.toString()]}>{it[value]}</Select.Option>
    )

    return items
}

export const renderSelectList = (source) => {
    if (source == null) return

    let items = source.map(item =>
        <Select.Option key={item} value={item}>{item}</Select.Option>
    )
    return items
}
